export default __webpack_public_path__ + "static/media/Geysers01.e26e4aca.webp";